import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return {
		header: {
			position: "relative",
			right: "5px",
		},
		headerContainer: {},
		headerTitle: {
			...{ color: theme.palette.custom.textPrimary },
		},
		loadingContainer: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			minHeight: 400,
		},
	} satisfies Record<string, CSSObject>;
};
